import { useCallback, useEffect } from 'react'
import { useStaticData } from '@mc/static-data-react'
import { trackEV, useExperiment } from '../../hooks/useExperiment'
import { useModalOverride } from '../../hooks/useModalOverride'
import { useUserInteractions } from '../../hooks/useUserInteractions'
import { GoogleFlyout } from './Variant1'
import { CustomModal } from './Variant2'

export const GoogleOneTap = () => {
  // common conditions to show the modals
  const { isEnabled, isVariant1, isVariant2, isControl } = useExperiment()
  const { isLoggedIn } = useStaticData<{ isLoggedIn: boolean }>()
  const { overridden } = useModalOverride()
  const { interacted, ban, isModalBanned } = useUserInteractions()

  const saveCloseAction = useCallback(
    (modal: 'google-flyout' | 'pop-up') => {
      ban(modal)
    },
    [ban],
  )

  useEffect(() => {
    if (!isLoggedIn && !overridden && interacted && isControl) {
      trackEV()
    }
  }, [isControl, isLoggedIn, overridden, interacted])

  if (!isEnabled || isLoggedIn || overridden || !interacted) return null

  if (isVariant1) {
    return (
      <GoogleFlyout
        isModalBanned={isModalBanned('google-flyout')}
        saveCloseAction={saveCloseAction}
      />
    )
  }

  if (isVariant2) {
    return (
      <CustomModal
        isModalBanned={isModalBanned('pop-up')}
        onClose={() => saveCloseAction('pop-up')}
      />
    )
  }

  return null
}
